module.exports = __webpack_public_path__ + "static/media/YB5M06_3.16baa52e.jpg";